export const DEFAULT_FILE_SIZE = 10000000 // unit relation -> 1000000 = 1MB

export const API_ENDPOINT = '/documento'
